// extracted by mini-css-extract-plugin
export default {"component_title":"DashboardTitle_component_title__dxMeg","element":"DashboardTitle_element__0RCvt"};